import { taskStates } from 'pages/Tasks/constants'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import { getPendingManagerOptions } from './get-pending-manager-options'
import { getTodoManagerOptions } from './get-todo-manager-options'

export const getOfficeActionButtons = (props: ResolveActionButtonsProps) => {
  const { task } = props

  switch (task.statusFe) {
    case taskStates.pending:
      return getPendingManagerOptions(props)
    case taskStates.todo:
      return getTodoManagerOptions(props)

    default:
      return []
  }
}
